import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { normalizeImageUrl } from '../utils/imageUrl';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Module-scoped cache with TTL so admin edits surface within ~30s without
// requiring a hard refresh. Also expose an `invalidatePageBackgrounds()`
// helper that PageEditor calls right after Save so the next navigation
// fetches fresh settings instantly.
let cachedSettings = null;
let cachedAt = 0;
const TTL_MS = 30 * 1000; // 30 seconds

export function invalidatePageBackgrounds() {
  cachedSettings = null;
  cachedAt = 0;
}

export default function PageBackground({ pageKey, children }) {
  const [bgImage, setBgImage] = useState(null);
  const [overlay, setOverlay] = useState(70);

  useEffect(() => {
    const loadSettings = async () => {
      const fresh = cachedSettings && (Date.now() - cachedAt) < TTL_MS;
      if (fresh) {
        setBgImage(cachedSettings[`page_bg_${pageKey}`] || null);
        setOverlay(cachedSettings[`page_overlay_${pageKey}`] || 70);
        return;
      }
      try {
        const res = await axios.get(`${BACKEND_URL}/api/system/settings`);
        cachedSettings = res.data;
        cachedAt = Date.now();
        setBgImage(res.data[`page_bg_${pageKey}`] || null);
        setOverlay(res.data[`page_overlay_${pageKey}`] || 70);
      } catch {}
    };
    loadSettings();
  }, [pageKey]);

  const imgUrl = normalizeImageUrl(bgImage);

  if (!imgUrl) return <>{children}</>;

  return (
    <div className="relative min-h-screen">
      <div
        className="fixed inset-0 bg-cover bg-center bg-no-repeat -z-10"
        style={{ backgroundImage: `url(${imgUrl})` }}
      />
      <div
        className="fixed inset-0 -z-10"
        style={{ backgroundColor: `rgba(0,0,0,${overlay / 100})` }}
      />
      {children}
    </div>
  );
}
